import { i18n } from "@lingui/core";
import React from 'react';
import { useLingui } from '@lingui/react';
import './contact.scss';
import SEO from '../components/shared/seo';
import Icon from '../components/shared/ui-elements/icon/icon';

var ContactPage = function ContactPage() {
  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var locale = i18n.locale;
  var width = 30;
  var height = 30;
  var color = 'rgb(245, 245, 245)';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, {
    title: i18n._(
    /*i18n*/
    i18n._("Contact")),
    lang: locale
  }), /*#__PURE__*/React.createElement("section", {
    className: "contact-page"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "contact-page__preference"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "mailto:kento.takeuchi.official@gmail.com",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-email",
    color: color
  })))), /*#__PURE__*/React.createElement("ul", {
    className: "contact-page__list"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://github.com/kentotakeuchi?tab=repositories",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-github",
    color: color
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.linkedin.com/in/takeuchi-kento-101b3549/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-linkedin",
    color: color
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.instagram.com/mikiotanaka/?hl=en",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-instagram",
    color: color
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/mikio.tanaka.001",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-facebook",
    color: color
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/KentoTakeuchi",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-twitter",
    color: color
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "tel:951-441-1777",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-phone",
    color: color
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.google.com/maps/place/Santa+Clara,+CA/@37.3710062,-122.037593,12z/data=!3m1!4b1!4m5!3m4!1s0x808fb7815c08c193:0xe475a47ca3c0bfc0!8m2!3d37.3541079!4d-121.9552356",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-location",
    color: color
  }))))));
};

export default ContactPage;